import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "packageTable",
  data: function data() {
    return {};
  },
  props: {
    packageTableClass: {
      //packageTable基本样式
      type: Boolean,
      default: true
    },
    packageTableTdPadding: {
      //packageTdPadding 单元格之间padding的样式
      type: Boolean,
      default: false
    },
    showSearchBtn: {
      //是否显示高级搜索
      type: Boolean,
      default: true
    },
    headBtnList: {
      //头部操作按钮list
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableData: {
      //表格数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnsData: {
      //表格列数据
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageSizeOpts: {
      type: Array,
      default: function _default() {
        return [15, 20, 50, 100, 200, 500, 1000];
      }
    },
    spanMethod: {},
    stripe: {
      //是否显示间隔斑马纹
      type: Boolean,
      default: false
    },
    border: {
      //是否显示纵向边框
      type: Boolean,
      default: false
    },
    showHeader: {
      //是否显示 表头
      type: Boolean,
      default: true
    },
    showTableHeader: {
      //是否显示header
      type: Boolean,
      default: true
    },
    showFooter: {
      //是否显示footer
      type: Boolean,
      default: true
    },
    height: {
      //表格高度
      type: Number
    },
    loading: {
      //表格loading
      type: Boolean,
      default: false
    },
    tabletotallen: {
      //分页总数
      type: Number,
      default: 0
    },
    tablePageSize: {
      //分页尺寸
      type: Number,
      default: 15
    },
    tablePageIndex: {
      //分页index
      type: Number,
      default: 1
    },
    reduceheight: {
      //默认需要减去的高度
      type: Number,
      default: 90
    },
    rowKey: {}
  },
  components: {},
  computed: {
    getTableHeight: function getTableHeight() {
      if (this.height) {
        return this.height;
      } else {
        console.log(this.$store.state.wh.innerHeight - this.reduceheight);
        return this.$store.state.wh.innerHeight - this.reduceheight;
      }
    }
  },
  methods: {
    nextpage: function nextpage() {
      //  debugger
      var time_end = localStorage.getItem('time_end');
      console.log("time_end_next_page", time_end); //let prev_time = localStorage.getItem('prev_time');

      this.$emit("nextpage", time_end);
    },
    prevpage: function prevpage() {
      // let time_start = localStorage.getItem('time_start');
      var prev_pages = localStorage.getItem('prev_time'); // let prev_time = localStorage.getItem('prev_time');

      this.$emit("prevpage", prev_pages);
    },
    pageOnchange: function pageOnchange(index) {
      this.$emit("pageonChange", index);
    },
    pageSizeChange: function pageSizeChange(pageSize) {
      localStorage.setItem('pageSize', pageSize);
      this.$emit("pageSizeChange", pageSize);
    },
    initcurrentPage: function initcurrentPage() {
      //重置当前currentpage
      this.$refs.pageRef.currentPage = 1;
    },

    /**
     * 显示面板btn操作
     */
    showSearchParel: function showSearchParel() {
      this.$emit("showSearchParel");
    },
    //选择改变时触发
    selectChange: function selectChange(selection) {
      this.$emit("getSelect", selection);
    },
    handleLoadData: function handleLoadData(item, callback) {
      this.$emit('handleLoadData', item, callback);
    }
  }
};